import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import * as Types from '../../../../types/api.types.generated.d';

const defaultOptions = {} as const;
export type ExpertLastExtractionQueryVariables = Types.Exact<{ [key: string]: never }>;

export type ExpertLastExtractionQuery = {
  __typename?: 'Query';
  expertLastExtraction: {
    __typename?: 'ExpertLastExtractionType';
    cvReupload: boolean;
    createdAt?: any | null;
  };
};

export const ExpertLastExtractionDocument = gql`
  query expertLastExtraction {
    expertLastExtraction {
      cvReupload
      createdAt
    }
  }
`;

/**
 * __useExpertLastExtractionQuery__
 *
 * To run a query within a React component, call `useExpertLastExtractionQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpertLastExtractionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpertLastExtractionQuery({
 *   variables: {
 *   },
 * });
 */
export function useExpertLastExtractionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ExpertLastExtractionQuery,
    ExpertLastExtractionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ExpertLastExtractionQuery, ExpertLastExtractionQueryVariables>(
    ExpertLastExtractionDocument,
    options,
  );
}
export function useExpertLastExtractionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ExpertLastExtractionQuery,
    ExpertLastExtractionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ExpertLastExtractionQuery, ExpertLastExtractionQueryVariables>(
    ExpertLastExtractionDocument,
    options,
  );
}
export function useExpertLastExtractionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ExpertLastExtractionQuery,
        ExpertLastExtractionQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ExpertLastExtractionQuery, ExpertLastExtractionQueryVariables>(
    ExpertLastExtractionDocument,
    options,
  );
}
export type ExpertLastExtractionQueryHookResult = ReturnType<typeof useExpertLastExtractionQuery>;
export type ExpertLastExtractionLazyQueryHookResult = ReturnType<
  typeof useExpertLastExtractionLazyQuery
>;
export type ExpertLastExtractionSuspenseQueryHookResult = ReturnType<
  typeof useExpertLastExtractionSuspenseQuery
>;
export type ExpertLastExtractionQueryResult = Apollo.QueryResult<
  ExpertLastExtractionQuery,
  ExpertLastExtractionQueryVariables
>;
export function refetchExpertLastExtractionQuery(variables?: ExpertLastExtractionQueryVariables) {
  return { query: ExpertLastExtractionDocument, variables };
}
